import { CreateCategoryComponent } from '@admin/person-of-interest/category/create-category/create-category.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChannelComponent } from './admin/channel/channel.component';
import { ChannelCreateComponent } from './admin/channel/create/channel-create.component';
import { ClientCreateComponent } from './admin/client/client-create/client-create.component';
import { ClientComponent } from './admin/client/client.component';
import { CustomerCreateComponent } from './admin/customer/create/customer-create.component';
import { CustomerComponent } from './admin/customer/customer.component';
import { CategoryComponent } from './admin/person-of-interest/category/category/category.component';
import { PersonOfInterestCreateComponent } from './admin/person-of-interest/create/person-of-interest-create.component';
import { PersonOfInterestComponent } from './admin/person-of-interest/person-of-interest.component';
import { SmsComponent } from './admin/sms/sms.component';
import { StartComponent } from './admin/start/start.component';
import { AdminGuard } from './core/auth/admin-guard.service';
import { AuthGuard } from './core/auth/auth-guard.service';
import { ConfirmEmailComponent } from './core/auth/confirm-email/confirm-email.component';
import { HangfireHandoffComponent } from './core/auth/hangfire-handoff/hangfire-handoff.component';
import { LoginComponent } from './core/auth/login/login.component';
import { RegisterComponent } from './core/auth/register/register.component';
import { ChooseTenantComponent } from './core/auth/choose-tenant/choose-tenant.component';
import { PublicLayotComponent } from '@app/layout/public-layot/public-layot.component';
import { PrivateLayotComponent } from '@app/layout/private-layot/private-layot.component';
import { MediaUploadExternalComponent } from '@admin/media-upload-external/media-upload-external.component';
import { ActiveReportEnum } from '@api/models/active-report-enum';
import { Permissions } from '@shared/models/enums/permissions.enum';
// import { PdfComponent } from './admin/pdf/pdf.component';

const PUBLIC_ROUTES: Routes = [
  {
    path: '',
    component: LoginComponent,
    title: '',
  },
  {
    path: 'login',
    component: LoginComponent,
    runGuardsAndResolvers: 'always',
    title: 'login',
  },
  {
    path: 'choose-tenant',
    component: ChooseTenantComponent,
    runGuardsAndResolvers: 'always',
    title: 'selectCustomer',
  },
  {
    path: 'register',
    component: RegisterComponent,
    runGuardsAndResolvers: 'always',
    title: 'register',
  },
  {
    path: 'confirm-email',
    component: ConfirmEmailComponent,
    runGuardsAndResolvers: 'always',
    title: 'forgotPassword',
  },
  {
    path: 'hangfire-handoff',
    component: HangfireHandoffComponent,
    title: '',
  },
  {
    path: 'uploadMediaFiles/:id',
    component: MediaUploadExternalComponent,
    title: 'media.upload',
  },
];

const PRIVATE_ROUTES: Routes = [
  {
    path: 'home',
    component: StartComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'home',
    data: {
      authorize: true,
    },
  },
  {
    path: 'media',
    loadChildren: () => import('./admin/media/media.module').then(m => m.MediaModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'media',
    data: {
      authorize: true,
      permissions: [Permissions.ViewMediaCms],
    },
  },
  {
    path: 'bookings',
    loadChildren: () => import('./admin/engagement/bookings/bookings.module').then(m => m.BookingsModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'bookings',
    data: {
      authorize: true,
      permissions: [Permissions.ViewBookingCms],
    },
  },
  {
    path: 'media-transfer',
    loadChildren: () => import('./admin/media-transfer/media-transfer.module').then(m => m.MediaTransferModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'media.transfer',
    data: {
      authorize: true,
      permissions: [Permissions.ViewMediaTransfer],
    },
  },
  {
    path: 'widgets',
    loadChildren: () => import('./admin/widgets/widgets.module').then(m => m.WidgetsModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'widgets.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewWidgets],
    },
  },
  {
    path: 'permissions',
    loadChildren: () => import('./admin/permissions/permissions.module').then(m => m.PermissionsModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'permissions.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewUserPermissionsAdmin],
    },
  },
  // Start - After POI is refactored to use modules, remove this
  // {
  //   path: 'people-counter-reports',
  //   component: ReportsComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     permissions: [Permissions.ViewPeopleCounterReportsInsights]
  //   }
  // },
  // {
  //   path: 'exposures-reports',
  //   component: ReportsComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     permissions: [Permissions.ViewExposuresReportsAnalytics]
  //   }
  // },
  // {
  //   path: 'poi-reports',
  //   component: ReportsComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     permissions: [Permissions.ViewPoiReportsInsights]
  //   }
  // },
  // {
  //   path: 'reach-reports',
  //   component: ReportsComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     permissions: [Permissions.ViewReachReportsAnalytics]
  //   }
  // },
  // End - After POI is refactored to use modules, remove this
  {
    path: '',
    loadChildren: () => import('./admin/engagement/book/book.module').then(m => m.BookModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'book.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewBookingCms],
    },
  },
  {
    path: 'customers',
    component: CustomerComponent,
    canActivate: [AuthGuard, AdminGuard],
    runGuardsAndResolvers: 'always',
    title: 'customers.title',
    data: {
      authorize: true,
    },
  },
  {
    path: 'customers/create',
    component: CustomerCreateComponent,
    canActivate: [AuthGuard, AdminGuard],
    runGuardsAndResolvers: 'always',
    title: 'customers.create',
    data: {
      authorize: true,
    },
  },
  {
    path: 'customers/:id',
    component: CustomerCreateComponent,
    canActivate: [AuthGuard, AdminGuard],
    runGuardsAndResolvers: 'always',
    title: 'customers.edit',
    data: {
      authorize: true,
    },
  },
  {
    path: 'sms',
    component: SmsComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'sms.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewSmsAdmin],
    },
  },
  {
    path: 'channels',
    component: ChannelComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'channels.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewChannelAdmin],
    },
  },
  {
    path: 'channels/create',
    component: ChannelCreateComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'channels.create',
    data: {
      authorize: true,
      permissions: [Permissions.UpdateChannelAdmin],
    },
  },
  {
    path: 'channels/:id',
    component: ChannelCreateComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'channels.edit',
    data: {
      authorize: true,
      permissions: [Permissions.UpdateChannelAdmin],
    },
  },
  {
    path: 'person-of-interest',
    component: PersonOfInterestComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'poi.title',
    data: {
      authorize: true,
      reportType: ActiveReportEnum.POI, // After POI is refactored to use modules, remove this
      permissions: [Permissions.ViewPoiInsights],
      actionPermissions: [Permissions.ExportPoiReportsInsights], // After POI is refactored to use modules, remove this
    },
  },
  {
    path: 'person-of-interest/create',
    component: PersonOfInterestCreateComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'poi.create',
    data: {
      authorize: true,
      permissions: [Permissions.UpdatePoiInsights],
    },
  },
  {
    path: 'person-of-interest/:id',
    component: PersonOfInterestCreateComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'poi.edit',
    data: {
      authorize: true,
      permissions: [Permissions.UpdatePoiInsights],
    },
  },
  {
    path: 'categories',
    component: CategoryComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'poi.categories.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewPoiCategoriesInsights],
    },
  },
  {
    path: 'categories/create',
    component: CreateCategoryComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'poi.categories.create',
    data: {
      authorize: true,
      permissions: [Permissions.UpdatePoiCategoriesInsights],
    },
  },
  {
    path: 'categories/:id/:customerId',
    component: CreateCategoryComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'poi.categories.edit',
    data: {
      authorize: true,
      permissions: [Permissions.UpdatePoiCategoriesInsights],
    },
  },
  {
    path: 'statistics',
    loadChildren: () => import('./admin/statistics/statistics.module').then(m => m.StatisticsModule),
  },
  {
    path: 'clients',
    component: ClientComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'clients.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewClientsAdmin],
    },
  },
  {
    path: 'client/create',
    component: ClientCreateComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'clients.create',
    data: {
      authorize: true,
      permissions: [Permissions.UpdateClientsAdmin],
    },
  },
  {
    path: 'client/:id',
    component: ClientCreateComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'clients.edit',
    data: {
      authorize: true,
      permissions: [Permissions.UpdateClientsAdmin],
    },
  },
  {
    path: 'contact-persons',
    loadChildren: () => import('./admin/contact-person/contact-person.module').then(m => m.ContactPersonModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'contact-persons',
    data: {
      authorize: true,
      permissions: [Permissions.ViewContactPersonAdmin],
    },
  },
  {
    path: 'users',
    loadChildren: () => import('./admin/user/user.module').then(m => m.UserModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'users.title',
    data: {
      authorize: true,
      permissions: [Permissions.ViewUsersAdmin],
    },
  },
  {
    path: 'settings',
    loadChildren: () => import('./admin/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard, AdminGuard],
    runGuardsAndResolvers: 'always',
    title: 'settings',
    data: {
      authorize: true,
    },
  },
  {
    path: 'about',
    loadChildren: () => import('./admin/about/about.module').then(m => m.AboutModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'about',
    data: { authorize: true },
  },
  {
    path: 'devices',
    loadChildren: () => import('./admin/screen/device.module').then(m => m.DeviceModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    title: 'devices',
    data: {
      authorize: true,
      permissions: [Permissions.ViewScreensAdmin],
    },
  },
  // FOR TESTING PURPOSES. Comment out when working with pdf generation
  // {
  //   path: 'pdf',
  //   component: PdfComponent,
  //   canActivate: [AuthGuard],
  //   runGuardsAndResolvers: 'always',
  //   title: 'devices',
  //   data: {
  //     authorize: true,
  //   },
  // },
];

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '',
    component: PublicLayotComponent,
    children: PUBLIC_ROUTES,
  },
  {
    path: '',
    component: PrivateLayotComponent,
    children: PRIVATE_ROUTES,
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
